import type { ComponentProps } from "react";

import { cn } from "~/shared/ui";
import { Skeleton } from "~/shared/ui/skeleton";

type Props = ComponentProps<typeof Skeleton>;

function StarRatingScaleSkeleton({ className, ...props }: Props) {
  return <Skeleton className={cn("h-4 w-20", className)} {...props} />;
}

export { StarRatingScaleSkeleton };
